module.exports = __webpack_public_path__ + "img/home_adapt_vertical_down_disabled.d87d2f75.svg";